(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heart-screening"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.screening-button').forEach(button => {
      button.addEventListener('click', (e) => {
        const href = button.getAttribute('href');
        
        // Check if it's a hash link (anchor)
        if (href && href.startsWith('#')) {
          e.preventDefault();
          
          // Remove the hash to get the section ID
          const targetId = href.substring(1);
          const targetSection = document.getElementById(targetId);
          
          if (targetSection && window.lenis) {
            // Use Lenis smooth scroll to the target section
            window.lenis.scrollTo(targetSection, {
              offset: -100, // Optional offset from top
              duration: 1.2, // Optional duration in seconds
              easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Optional easing
              lock: true // Prevent wheel/touch from interrupting during programmatic scroll
            });
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
